import { Link } from "@/components/common/Link";
import { Twitter, Linkedin, Github } from "lucide-react";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
export default function SystemFooter() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="224291" id="footer" className="bg-background border-t-4 border-primary py-6 text-foreground">
      <div className="container mx-auto px-4 md:px-8 flex flex-col md:flex-row items-center justify-between gap-6">
        <Link to="/">
          {}
          <WvcLogo className="h-9 w-auto" />
        </Link>
        <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6">
          <Link to="/Home" aria-label="Home">
            
          </Link>
          <span className="text-xs font-default text-foreground">© {currentYear} Peace River Pest Control.</span>
        </div>

        {}
        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8">
          <nav className="flex items-center gap-4 md:gap-6 text-xs font-default text-foreground">
            <Link to="/PestControlPage" className="hover:underline transition-colors">
              Pest Control
            </Link>
            <Link to="/TermiteTreatmentPage" className="hover:underline transition-colors">
              Termite Treatment
            </Link>
            <Link to="/ContactPage" className="hover:underline transition-colors">
              Customer Portal
            </Link>
          </nav>

          <div className="flex items-center gap-2">
            <Link to="#" aria-label="Twitter" className="flex items-center justify-center size-8 rounded-lg bg-primary text-foreground hover:bg-primary/80 transition-colors">
              <Twitter className="size-3.5" />
            </Link>
            <Link to="#" aria-label="LinkedIn" className="flex items-center justify-center size-8 rounded-lg bg-primary text-foreground hover:bg-primary/80 transition-colors">
              <Linkedin className="size-3.5" />
            </Link>
            <Link to="#" aria-label="GitHub" className="flex items-center justify-center size-8 rounded-lg bg-primary text-foreground hover:bg-primary/80 transition-colors">
              <Github className="size-3.5" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}